import { ReactNode } from 'react';

import { createBoundContext } from '@bonusly/ds-utils';

export type DropdownContextValue = {
	id?: string;
	isOpen: boolean;
	name?: string;
	onChange: (value: any) => void;
	onScrollToBottom?: () => void;
	placeholder?: ReactNode;
	renderOption?: (value: any) => ReactNode;
	value?: any;
	valueToString?: (value: any) => string;
};

export const [DropdownContext, useDropdownContext] = createBoundContext<DropdownContextValue>({
	providerName: 'DropdownProvider',
	hookName: 'useDropdownContext',
});
